/*global chrome*/
import React, { useState, useEffect } from "react";
import "./FeedbackForm.css";
import robotIcon from "../assets/dark.png";

const FeedbackForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    platforms: {
      "Google Meet": false,
      "Zoom": false,
      "MS Teams": false,
    },
    otherFeatures: {
      "Auto-compose emails": false,
      "Extension Thunai Chat": false,
      "Research": false,
    },
    uninstallReason: "", // Changed
    otherReason: "",
    improvementFeedback: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [submitSuccess, setSubmitSuccess] = useState(false);

  // Load user profile from Chrome storage on component mount
  // useEffect(() => {
  //   // For Chrome extension
  //   if (typeof chrome !== 'undefined' && chrome.storage) {
  //       chrome.storage.sync.get('profile', (result) => {
  //           let profile = result?.profile;

  //           if (profile && typeof profile === 'string') {
  //             try {
  //               profile = JSON.parse(profile);
  //             } catch (e) {
  //               console.error("Failed to parse profile string:", e);
  //               return;
  //             }
  //           }

  //           if (profile && typeof profile === 'object') {
  //             console.log("Username:", profile.username);
  //             setFormData(prev => ({
  //               ...prev,
  //               name: profile.username || '',
  //               email: profile.emailid || ''
  //             }));
  //           } else {
  //             console.log("Profile is not present or malformed.");
  //           }
  //         });
  //   }

  // }, []);

  useEffect(() => {
    // Get parameters from the current URL
    const getParametersFromURL = () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const name = urlParams.get("name");
        const email = urlParams.get("email");

        console.log("URL Parameters - Name:", name, "Email:", email);

        if (name || email) {
          setFormData((prev) => ({
            ...prev,
            name: name || "",
            email: email || "",
          }));
        } else {
          console.log("Name and email not found in URL parameters");
        }
      } catch (error) {
        console.error("Error extracting parameters from URL:", error);
      }
    };

    // For Chrome extension, try to get parameters from URL
    if (typeof window !== "undefined") {
      getParametersFromURL();
    } else {
      console.log("Window object not available");
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCheckboxChange = (platform) => {
    setFormData({
      ...formData,
      platforms: {
        ...formData.platforms,
        [platform]: !formData.platforms[platform],
      },
    });
  };


  const handleOtherFeaturesChange = (otherFeatures) => {
    setFormData({
      ...formData,
      otherFeatures: {
        ...formData.otherFeatures,
        [otherFeatures]: !formData.otherFeatures[otherFeatures],
      },
    });
  };

  // Replace the current handleReasonChange function with:
  const handleReasonChange = (selectedReason) => {
    setFormData({
      ...formData,
      uninstallReason: selectedReason,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError("");

    try {
      // Extract selected platforms
      const extensionRecord = Object.keys(formData.platforms).filter(
        (platform) => formData.platforms[platform]
      );

      const features = Object.keys(formData.otherFeatures).filter(
        (otherFeatures) => formData.otherFeatures[otherFeatures]
      );

      let uninstallReason = formData.uninstallReason;
      if (uninstallReason === "Other" && formData.otherReason) {
        uninstallReason += `: ${formData.otherReason}`;
      }

      // Prepare payload
      const payload = {
        payload: {
          name: formData.name,
          email: formData.email,
          extension_record: extensionRecord,
          other_features: features,
          uninstall_reason: uninstallReason,
          feedback: formData.improvementFeedback,
        },
      };

      console.log("Submitting payload:", payload);

      // Send data to API
      const response = await fetch(
        "https://api.thunai.ai/track-service/v1//chrome/store/feedback",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const responseData = await response.json();
      console.log("Submission successful:", responseData);

      setSubmitSuccess(true);

      // Reset form after successful submission if needed
      // resetForm();
    } catch (error) {
      console.error("Error submitting feedback:", error);
      setSubmitError("Failed to submit feedback. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="feedback-container">
      <div className="feedback-content">
        <div className="feedback-header">
          <img src={robotIcon} alt="Robot Icon" className="robot-icon" />
          <h1>Thunai Chrome Extension Feedback</h1>
        </div>

        <div className="feedback-description">
          <p>We want to make this new chrome extension better!</p>
          <p>
            We'd love your feedback so that we can quickly address any
            issues/bugs.
          </p>
        </div>

        {submitSuccess ? (
          <div className="success-message">
            <h2>Thank you for your feedback!</h2>
            <p>
              We appreciate your input and will use it to improve our extension.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="feedback-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Name*</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email*</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="form-group platform-section">
              <label>
                What platforms did you try to record from the extension?*
              </label>

              {Object.keys(formData.platforms).map((platform) => (
                <div
                  key={platform}
                  className={`platform-option ${
                    formData.platforms[platform] ? "selected" : ""
                  }`}
                  onClick={() => handleCheckboxChange(platform)}
                >
                  <span>{platform}</span>
                  <div className="checkbox">
                    {formData.platforms[platform] && (
                      <span className="checkmark">✓</span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="form-group otherFeatures-section">
              <label>
              Did you also try?*
              </label>

              {Object.keys(formData.otherFeatures).map((otherFeatures) => (
                <div
                  key={otherFeatures}
                  className={`otherFeatures-option ${
                    formData.otherFeatures[otherFeatures] ? "selected" : ""
                  }`}
                  onClick={() => handleOtherFeaturesChange(otherFeatures)}
                >
                  <span>{otherFeatures}</span>
                  <div className="checkbox">
                    {formData.otherFeatures[otherFeatures] && (
                      <span className="checkmark">✓</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
            

            <div className="form-group reason-section">
              <label>Why are you uninstalling the extension?*</label>

              {[
                "Doesn't work with other platforms",
                "Auto capturing all my meetings",
                "Speaker labels not accurate",
                "Not working as expected",
                "No longer needed",
                "Other",
              ].map((reason) => (
                <div
                  key={reason}
                  className={`reason-option ${
                    formData.uninstallReason === reason ? "selected" : ""
                  }`}
                  onClick={() => handleReasonChange(reason)}
                >
                  <span>{reason}</span>
                  <div className="checkbox">
                    {formData.uninstallReason === reason && (
                      <span className="checkmark"></span>
                    )}
                  </div>
                </div>
              ))}

              {formData.uninstallReason === "Other" && (
                <div className="form-group">
                  <input
                    type="text"
                    name="otherReason"
                    value={formData.otherReason}
                    onChange={handleInputChange}
                    placeholder="Specify other..."
                    className="other-reason-input"
                    required
                  />
                </div>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="improvementFeedback">
                What can we improve in the extension?*
              </label>
              <textarea
                id="improvementFeedback"
                name="improvementFeedback"
                value={formData.improvementFeedback}
                onChange={handleInputChange}
                rows={5}
                required
              />
            </div>

            {submitError && <div className="error-message">{submitError}</div>}

            <div className="form-group submit-section">
              <button
                type="submit"
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default FeedbackForm;
